export default __webpack_public_path__ + "static/media/Spear of Nephren-Ka.d66ec67b.jpg";